import { createContext, useContext, useState, type ReactNode } from "react";

interface ExploreCityContextValue {
  cityId: string | null;
  setCityId: (id: string | null) => void;
}

const ExploreCityContext = createContext<ExploreCityContextValue>({
  cityId: null,
  setCityId: () => {},
});

export function ExploreCityProvider({ children }: { children: ReactNode }) {
  const [cityId, setCityId] = useState<string | null>(null);
  return (
    <ExploreCityContext.Provider value={{ cityId, setCityId }}>
      {children}
    </ExploreCityContext.Provider>
  );
}

export function useExploreCity() {
  return useContext(ExploreCityContext);
}
